import { Drawer, Skeleton } from 'antd'
import React, { Suspense } from 'react'

import { drawerAndModalWidth } from '../../../util/guideline'
import { UpdateCouponDates } from './UpdateCouponDates'

interface UpdateCouponDatesProps {
  tradeId: number
  domain: string
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateCouponDatesDrawer = ({ tradeId, domain, isVisible, onSuccess, onClose }: UpdateCouponDatesProps) => (
  <Drawer
    title="Update Coupon Dates"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <Suspense fallback={<Skeleton />}>
      <UpdateCouponDates tradeId={tradeId} domain={domain} onSuccess={onSuccess} />
    </Suspense>
  </Drawer>
)
